// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c561b08","455":"d03f429d","977":"ddc060bb"}[chunkId] + ".chunk.js";
};